(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["limitless-special-orders"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('limitless-special-orders')) {
    class LimitlessSpecialOrders extends HTMLElement {
      connectedCallback() {
        this.brand = this.querySelector('[data-special-order-brand]');
        this.other = this.querySelector('[data-special-order-other]');
        this.otherInput = this.querySelector('[data-special-order-other-input]');
        this.otherRequired = this.querySelector('[data-special-order-other-required]');
        if (!this.brand || !this.other || !this.otherInput) return;

        this.updateOtherBrand = this.updateOtherBrand.bind(this);
        this.brand.addEventListener('change', this.updateOtherBrand);
        this.updateOtherBrand();
      }

      disconnectedCallback() {
        this.brand?.removeEventListener('change', this.updateOtherBrand);
      }

      updateOtherBrand() {
        const showOther = this.brand.value === 'Otra';
        this.other.hidden = !showOther;
        this.otherInput.disabled = !showOther;
        this.otherInput.required = showOther;
        if (this.otherRequired) this.otherRequired.hidden = !showOther;
      }
    }

    customElements.define('limitless-special-orders', LimitlessSpecialOrders);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
